module.exports = __webpack_public_path__ + "img/mail.f99580af.svg";